module.exports = __webpack_public_path__ + "static/media/create-campaign-completed.16b1a7de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/create-campaign-completed.png
// module id = 1264
// module chunks = 1